import {Component, OnInit} from '@angular/core';
import {ClientesService} from "./clientes.service";
import {ClientesModel} from "./clientes.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {TiposClientesService} from "./tipos-clientes.service";

declare var swal, $: any;

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html'
})
export class ClientesComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"tipo":"", "nome":""};

  clientes: ClientesModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  podeFaturar = false;

  listTiposClientes = [];

  constructor(
    formBuilder: FormBuilder,
    private clientesService: ClientesService,
    private tiposClientesService: TiposClientesService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'clientes'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;

        }else if(data.privilegios[i].acao[0].url == 'financeiro'){
          this.podeFaturar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      tipo: [],
      nome: []
    });

    this.tiposClientesService.get()
      .subscribe(
        json => {
          let tipos = (json.Payload || []).filter(tipo => tipo.id_tipo !== '2' && tipo.id_tipo !== '3' && tipo.id_tipo !== '5' && tipo.id_tipo !== 2 && tipo.id_tipo !== 3 && tipo.id_tipo !== 5);

          let hasTipo8 = tipos.some(t => String(t.id_tipo) === '8');
          if (!hasTipo8) {
            tipos.push({
              id_tipo: '8',
              nome_pt: 'Marítimo / Exames',
              nome_en: 'Maritime / Examinations',
              nome_es: 'Marítimo / Exámenes'
            });
          }

          this.listTiposClientes = tipos;
        },
        error => {
          this.func.showErro(error.json());
        });

  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = filtroSalvo;
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }
    this.getPage(1);
  }

  delete(cliente) {
    let clientes = this.clientes;
    let clientesService = this.clientesService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarCliente')+cliente.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(clientes);
        }

        let index = clientes.indexOf(cliente);
        clientes.splice(index, 1);

        clientesService.apagar(cliente.id_cliente)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.clientes = clientes;
            },
            err => {
              // Revert the view back to its original state
              clientes.splice(index, 0, cliente);
              self.clientes = clientes;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.nome != ''){
      filtros['nome_tratamento'] = '**:'+this.filtroPesquisa.nome;
    }

    let tipo = null;
    if(this.filtroPesquisa.tipo != ''){
      tipo = this.filtroPesquisa.tipo;
    }

    this.clientesService.getPaginacao(pagina, this.itensPorPagina, ['tipos'], filtros, null, {'nome':'a'}, tipo)
      .subscribe(data => {
        this.clientes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  gerarFatura(id_cliente){

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaGerarFatura'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){

        self.clientesService.gerarFatura(id_cliente)
          .subscribe(res => {

            },
            err => {
              self.func.showErro(err.json());
            });

      });

  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"tipo":"", "nome":""};
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

}



// WEBPACK FOOTER //
// ./src/app/clientes/clientes.component.ts